/** Recently added to ActiveCampaign: the contacts the last waves created, newest first. */
import type { RecentlyAddedPerson } from "../../../../api/audienceReview.types";
import { fmtDate, standingOf } from "../format";
import type { PersonLine, ViewDef } from "../views";

export const RECENTLY_ADDED: ViewDef = {
  id: "recently-added-ac",
  title: "Recently added to ActiveCampaign",
  menu: "Recently added",
  paged: false,
  emails: "rows",
  columns: [
    { key: "standing", label: "Standing", kind: "standing" },
    { key: "wave", label: "Wave", always: true },
    { key: "date", label: "Added", kind: "date", always: true },
  ],
  empty: "No one was added lately.",
};

export function recentlyAddedLine(p: RecentlyAddedPerson): PersonLine {
  return {
    id: p.memberId,
    name: p.name,
    email: p.email,
    standing: standingOf(p.standing),
    cells: { wave: p.runLabel.replace(/^Batch\b/, "Wave"), date: fmtDate(p.createdAt) },
  };
}
